import { PaymentStatus, RewardStatus } from '../rewards';

export enum RetailerReviewConfigStatus {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export enum EligibilityStatus {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}

export type RetailerSyncConfig = {
  clientSide: EligibilityStatus;
  serverSide: EligibilityStatus;
  autoSync?: EligibilityStatus;
};

export type RetailerCheckoutConfig = {
  clientSide: EligibilityStatus;
  serverSide: EligibilityStatus;
  minOrderAmount?: number;
};

export interface RetailerReviewConfig {
  status: RetailerReviewConfigStatus;
  retailerId: number;
  dailyMaxUnverifiedReviews?: number;
  minRetailerSales?: number;
  maxVerifiedReviewsL5dForUser?: number;
  maxUnverifiedReviewsL5dForUser?: number;
}

export interface Retailer {
  retailerId: number;
  parentRetailerId: number;
  name: string;
  color: string;
  displayName: string;
  type: string;
  currencySymbol: string;
  locale: string;
  logo: string;
  baseOrderUrl: string;
  isBrandClubReady: boolean;
  isSocialPlatform: boolean;
  retailerConnectRewardAmount?: number;
  existingRetailerConnectReward?: {
    rewardAmount: number;
    rewardStatus: RewardStatus;
    paymentStatus: PaymentStatus;
    rewardCurrency: 'USD';
    createdTime: Date;
  };
  reviewConfig: {
    status: 'enabled' | 'disabled';
    retailerId: number;
    dailyMaxUnverifiedReviews?: number;
    minRetailerSales?: number;
    maxVerifiedReviewsL5dForUser?: number;
    maxUnverifiedReviewsL5dForUser?: number;
  };
  syncConfig: RetailerSyncConfig;
  checkoutConfig: RetailerCheckoutConfig;
}
